var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ad--container"},[_c('Adsense',{attrs:{"data-ad-client":"ca-pub-7702415526221680","data-ad-slot":"8750381466","data-ad-format":"auto","data-full-width-responsive":"true"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }